<div class="supplementary-equipment">
  <div class="dialog-layout">

    <h2 class="dialog-h2">
      <sc-dictionary-label dictionaryKey="tmc.transport.supplementaryEquipment.handout.title"></sc-dictionary-label></h2>




      <div class="top-info">
        <app-transport-info-panel [carrier]="transport.carrier" [identifier]="transport.identifier"
				[driver]="transport.name" [scope]="transport.transportScope"></app-transport-info-panel>
      </div>

      <div class="dialog-content" [formGroup]="formGroup">

        <sc-flex vertical stretchContent class="no-field-space">
          @if (forceConfirmSupplementaryEquipment) {
            <div class="no-supplementary-cbx form-checkbox"
              >
              <div class="checkbox-label">
                <mat-checkbox [(ngModel)]="transport.noSupplementaryEquipmentHandout" [ngModelOptions]="{standalone: true}"
                  [disabled]="isNoSupplementaryEquipmentHandoutDisabled()">
                  <sc-dictionary-label dictionaryKey="tmc.transport.supplementaryEquipment.handout.label.nosupplementaryequipmenthandout"></sc-dictionary-label>
                </mat-checkbox>
              </div>
            </div>
          }
          @for (se of transport.supplementaryEquipments; track se) {
            <sc-content-spacer vertical></sc-content-spacer>
            <sc-flex [formGroupName]="se.equipmentTypeId">
              <div class="checkbox-label">
                <mat-checkbox formControlName="selected" [disabled]="isNoSupplementaryEquipmentHandoutSelected()">
                  {{ se.name }}
                </mat-checkbox>
              </div>
              @if (se.availableIdentifiers?.length > 0) {
                <sc-content-spacer></sc-content-spacer>
                <mat-form-field class="checkbox-value" appearance="fill">
                  <mat-label>
                    <sc-dictionary-label dictionaryKey="tmc-common.equipment.entity.equipment.identifier"></sc-dictionary-label></mat-label>
                    <mat-select formControlName="identifier" required="true">
                      @for (identity of se.availableIdentifiers; track identity) {
                        <mat-option [value]="identity">{{identity}}</mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                }
              </sc-flex>
            }
          </sc-flex>
        </div>


    <div class="messages">
      <app-service-response [responseMessages]="responseMessages"></app-service-response>
        <div class="messages">
          <app-service-response [responseMessages]="responseMessages"></app-service-response>
        </div>

        <sc-actionbar>
          <sc-content-spacer grow></sc-content-spacer>
          <sc-cancel-button (click)="cancel()"></sc-cancel-button>
          <sc-content-spacer></sc-content-spacer>
          <sc-confirm-button (click)="save()"  [disabled]="isSaveDisabled()"></sc-confirm-button>
        </sc-actionbar>
      </div>
  </div>
</div>
